import {
    getQueryKey,
    ShadcnSuspenseQueryProps,
    useShadcnSuspenseQuery,
} from '@shadcn-features/query';
import { queryOptions } from '@app/configs/query';
import { LanguageQueryKey } from '@shared/components/LanguageSelect';
import { ResponseType } from '@shared/types/types';

export const useQuerySuspenseFetch = <
    TResponseData,
    TSelectData = TResponseData,
    TParams extends Record<string, unknown> = Record<string, unknown>,
    TBody = unknown,
>(
    url: string,
    options?: Omit<
        ShadcnSuspenseQueryProps<
            ResponseType<TResponseData>,
            TParams,
            TBody,
            TResponseData,
            TSelectData
        >,
        'url'
    > & { language?: boolean; mockData?: TResponseData },
) => {
    const { mockData, ...restOptions } = options ?? {};

    return useShadcnSuspenseQuery<
        ResponseType<TResponseData>,
        TParams,
        TBody,
        TResponseData,
        TSelectData
    >(queryOptions, {
        url,
        ...restOptions,
        ...(mockData !== undefined && {
            queryFn: async (): Promise<ResponseType<TResponseData>> => ({
                isSuccess: true,
                code: 'SUCCESS',
                data: mockData,
            }),
        }),
        queryKey: options?.language
            ? getQueryKey({ url: LanguageQueryKey, key: options?.queryKey })
            : options?.queryKey,
    });
};
